import { render } from "./TotalAppointmentsCard.vue?vue&type=template&id=10f72181&scoped=true"
import script from "./TotalAppointmentsCard.vue?vue&type=script&lang=js"
export * from "./TotalAppointmentsCard.vue?vue&type=script&lang=js"

import "./TotalAppointmentsCard.vue?vue&type=style&index=0&id=10f72181&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f72181"]])

export default __exports__